import React from "react";
import { InfoCircleOutlined, ArrowRightOutlined, WarningOutlined } from "@ant-design/icons";
import styles from "./SwmsWizard.module.css";

export default function SwmsWizardStep1({
  categories,
  catLabels,
  selectedCategories,
  showValidation,
  onToggleCategory,
  onContinue
}) {
  return (
    <div className={styles.stepBody}>
      <h1 className={styles.stepTitle}>Step 1: Select Access Categories</h1>
      <p className={styles.stepSubtitle}>Choose one or more access categories for your SWMS.</p>

      <div className={styles.infoBanner}>
        <InfoCircleOutlined className={styles.infoBannerIcon} />
        Select all categories that apply. You can combine multiple work methods in a single document.
      </div>

      <div className={styles.categoryGrid}>
        {categories.map((cat) => {
          const isSelected = selectedCategories.includes(cat.id);
          const cardClass = isSelected
            ? `${styles.categoryCard} ${styles.selected}`
            : styles.categoryCard;
          const catName = catLabels[cat.id] || cat.category_name || "";
          const catDesc = cat.description || "";

          return (
            <div
              key={cat.id}
              className={cardClass}
              onClick={() => onToggleCategory(cat.id)}
            >
              <div className={styles.categoryCardContent}>
                <div className={styles.categoryCardHeader}>
                  <p className={styles.categoryCardTitle}>{catName}</p>
                  <input
                    type="checkbox"
                    className={styles.categoryCheckbox}
                    checked={isSelected}
                    onChange={() => onToggleCategory(cat.id)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <p className={styles.categoryCardDescription}>{catDesc}</p>
              </div>
            </div>
          );
        })}
      </div>

      {showValidation && (
        <div className={styles.validationMsg}>
          <WarningOutlined />
          Please select at least one access category to continue.
        </div>
      )}

      <div className={styles.stepFooter}>
        <button className={styles.continueButton} onClick={onContinue}>
          Continue to Methods
          <ArrowRightOutlined />
        </button>
      </div>
    </div>
  );
}
